module.exports = __webpack_public_path__ + "static/media/blob-qr.c5f161a9.svg";